<template>
  <VaNavbar class="app-layout-navbar bg-white">
    <template #left>
      <div class="left box-border d-flex align-items-center">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="isSidebarMinimized = !isSidebarMinimized"
            class="pr-2"
          />
        </Transition>
        <RouterLink to="/" aria-label="Visit home page">
          <div class="flex items-center justify-center">
            <TMLogo />
            <VaDropdown v-if="!isMobile && isSidebarMinimized && route.name !== 'project'" class="ml-3">
              <ProjectActions />
            </VaDropdown>
          </div>
        </RouterLink>
      </div>
      <div v-if="!isMobile && !isSidebarMinimized && route.name !== 'project'" class="d-flex align-items-center border-l border-gray-200">
        <ProjectActions />
      </div>
    </template>
    <template #right>
      <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import AppNavbarActions from './components/AppNavbarActions.vue'
import ProjectActions from './components/ProjectActions.vue'
import { useUserStore } from 'obst/user-store'
import TMLogo from '../TMLogo.vue'
import { useRoute } from 'vue-router'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()

const route = useRoute()

const { isSidebarMinimized } = storeToRefs(GlobalStore)
</script>

<style lang="scss" scoped>
.app-skin-dark .app-layout-navbar {
  border-bottom: 1px solid rgb(27, 36, 54) !important;
  padding: 0;
}

.app-skin-dark .left {
  border-right: 1px solid rgb(27, 36, 54) !important;
}
</style>
